"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.frame = void 0;
const tslib_1 = require("tslib");
const internal_1 = require("../internal");
const events_1 = require("../events");
const frameEventKey = (eventKey, frameId) => `frame:${eventKey}:${frameId}`;
const EVENT_KEY_FRAME_PROPS = 'props';
const EVENT_KEY_FRAME_LOADED = 'loaded';
const onPropsUpdate = (handler) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const frameId = yield (0, internal_1.getFrameId)();
    if (!frameId) {
        throw new Error('Frame could not be found, please ensure the custom props enabled Frame component is set up correctly.');
    }
    const sub = events_1.events.on(frameEventKey(EVENT_KEY_FRAME_PROPS, frameId), handler);
    const unsubscribe = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const subscription = yield sub;
        subscription.unsubscribe();
    });
    void events_1.events.emit(frameEventKey(EVENT_KEY_FRAME_LOADED, frameId), { loaded: true });
    return unsubscribe;
});
exports.frame = {
    onPropsUpdate
};
